import React from 'react'
import CustomCreate from './CustomCreate'

//image
import ElonMuskImg from '../../../../images/ElonMusk.jpg';
import Default from '../../../../images/default.png'

function RecentlySearched({
    searchedContactLastFive,
    showCustom,
    setShowCustom,
    FBvalueProp,
    auth,
    fbProfile,
    tokens,
    interestValues,
    callToAction,
    firstCopy,
    setProfile,
    setLIurl,
    setInterests,
    setContentGen,
    setFoundInts,
    setDocId,
    teamToken,
    tokensTeam
}) {

    const handleClick = (contactIndex) =>{
        const lastsearchedProfile = {
            profile_pic_url: searchedContactLastFive[contactIndex]?.contactImg.includes("proxycurl") ? Default :searchedContactLastFive[contactIndex]?.contactImg,
            full_name: searchedContactLastFive[contactIndex]?.contactName,
            first_name: searchedContactLastFive[contactIndex]?.contactFirstName,
            last_name: searchedContactLastFive[contactIndex]?.contactLastName, 
            headline: searchedContactLastFive[contactIndex]?.contactHeadline,
            city: searchedContactLastFive[contactIndex]?.contactCity,
            experiences:[{company: searchedContactLastFive[contactIndex]?.contactCompany}],
            summary: searchedContactLastFive[contactIndex]?.contactSummary,
            activities: searchedContactLastFive[contactIndex]?.contactActivities,
            articles: searchedContactLastFive[contactIndex]?.contactArticles
        }

        setProfile(lastsearchedProfile)
        setLIurl(searchedContactLastFive[contactIndex]?.contactLinkdinUrl)
        setInterests(searchedContactLastFive[contactIndex]?.contactInterest)
        setContentGen(searchedContactLastFive[contactIndex]?.message)
        setFoundInts(searchedContactLastFive[contactIndex]?.contactContent)
        setDocId(searchedContactLastFive[contactIndex]?.docId)

        // console.log(searchedContactLastFive[contactIndex])
    }

    return (
        <div className="py-4 flex">
            <div className="bg-white shadow sm:rounded-lg rounded-lg w-1/2">
                <div className="px-4 py-5 sm:p-6">
                    {(searchedContactLastFive?.length > 0) ?
                    <div>
                        <h2 className="text-2xl font-semibold text-gray-900">Recently Searched</h2>
                        {searchedContactLastFive?.map((contact, index) =>{
                            return(
                                <button 
                                    key={index}
                                    className='block w-full focus:outline-none'
                                    onClick={() => handleClick(index)}
                                >
                                    <div 
                                    className="px-4 py-5 mt-5 sm:p-6 flex border-2 border-gray-200 rounded shadow hover:bg-gray-100"
                                    >
                                        <div className='flex'>
                                            <div>
                                            {(contact?.contactName === 'Elon Musk') ? 
                                                <img 
                                                    src={ElonMuskImg} 
                                                    alt='searched' 
                                                    className="rounded-full h-24"
                                                />
                                            :
                                                (contact.contactImg.includes("proxycurl") ?
                                                <img 
                                                    src={Default} 
                                                    alt='searched' 
                                                    className="rounded-full h-24"
                                                />
                                                :
                                                <img 
                                                    src={contact.contactImg} 
                                                    alt='searched' 
                                                    className="rounded-full h-24"
                                                />
                                                )
                                            }
                                            </div>
                                            <div className="ml-8 text-left">
                                                <h1 className='text-2xl font-bold'>
                                                    {contact?.contactName}
                                                </h1>
                                                <h1 className="text-lg font-medium mt-2">
                                                    {contact?.contactCompany}  
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            )
                        })}
                    </div> 
                    :
                    <div className="border-4 border-dashed border-gray-300 mt-1 rounded p-6">
                        <h1 className="text-base text-gray-400">
                        Paste a Linkedin URL above to get started!
                        </h1>
                    </div>
                    }
                </div>
            </div>
            <div className="bg-white shadow sm:rounded-lg rounded-lg w-1/2 ml-4">
                {showCustom ? 
                <CustomCreate 
                FBvalueProp={FBvalueProp}
                auth={auth}
                fbProfile={fbProfile}
                tokens={tokens}
                interestValues={interestValues}
                callToAction={callToAction}
                firstCopy={firstCopy}
                teamToken={teamToken}
                tokensTeam={tokensTeam}
                />
                :
                <div className="p-4 text-center border-4 border-dashed border-gray-300 m-6 rounded">
                    <h1 className="text-xl mt-2 font-semibold text-gray-600">Create Custom Message</h1>
                    <div className="mt-2">
                        <button
                        className="bg-green-500 border-2 border-green-300 hover:bg-green-300 px-4 py-2 rounded text-white font-semibold text-lg focus:outline-none"
                        onClick={() => setShowCustom(true)}
                        >
                            Create
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default RecentlySearched
